/**
 * Created by fworld on 2019/6/29.
 */
const faults = [
    {
        name: 'delivery.faults',
        path: 'faults',
        meta: {title: '设备列表'},
        component: () => import('@/pages/Delivery/Device/Devices/faults'),
    },

]

export default faults
